export class ChangePasswordModel {
    userId: number;
    currentPassWord: string;
    newPassWord: string;
}
